import { BRAND } from "constants/brand";
import "./loadingSpinner.scss";
import { Ring } from "@uiball/loaders";

const LoadingSpinner = () => {
    return (
        <div className="lazy-loading-spinner center">
            <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
        </div>
    );
};
export default LoadingSpinner;
